<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div *ngIf="errorMessage" class="error-message">
        <pa-message [description]="errorMessage" (messageState)="messageState($event)"></pa-message>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <div class="col-12 px-0 d-flex justify-content-between">
          <label class="title">Üye Ol</label>
          <button class="card-question-button" (click)="cancelAccount()">
            <span
              class="text-style">{{this.textService.keyValueMapping('cardValidationCancelButton', 'Bu kartlar bana ait değil', sdkInitTexts)}}</span>
          </button>
          <!--          <label class="card-question"-->
          <!--                 (click)="cancelAccount()">{{this.textService.keyValueMapping('cardValidationCancelButton', 'Bu kartlar bana ait değil',sdkInitTexts)}}</label>-->
        </div>
        <div class="col-12 px-0 d-flex">
          <label
            class="cart-title">{{this.textService.keyValueMapping('cardValidationHeader', 'Kart Doğrulama', sdkInitTexts)}}</label>
        </div>
        <div class="col-12 px-0 d-flex">
          <label
            class="cart-description">{{this.textService.keyValueMapping('cardValidationDescription', 'Güvenliğiniz için devam etmeden önce kayıtlı kartlarından birini doğrulaman\n' +
            '            gerekmektedir. Kartın son kullanım tarihini doğru girerek doğrulayabilirsin.', sdkInitTexts)}}</label>
        </div>
        <div class="col-12 px-0 d-flex overflow-auto form-div">
          <form [formGroup]="cardFormGroup" class="form-style">
            <ng-container>
              <div style="margin-top: 16px">
                <mat-accordion class="w-100">
                  <mat-expansion-panel #panel1 *ngFor="let card of cards.controls; index as i" [expanded]="i==0"
                                       (opened)="setSelectedCard(card.value)" hideToggle>
                    <mat-expansion-panel-header class="panel">
                      <mat-panel-title>
                        <div>
                          <mat-radio-button class="radio-button-style"
                                            [checked]="panel1.expanded"></mat-radio-button>
                        </div>
                        <img class="card-size" [src]="'assets/images/paycell-card-one.png'"
                             [srcset]="'assets/images/paycell-card-one@2x.png 2x, assets/images/paycell-card-one@3x.png 3x'"
                             alt="logo"/>
                        <!--<img *ngIf="!card.value.cardBrand" class="card-size"
                             src="/assets/img/{{ card.value.cardBrand }}inactive.png">-->
                        <label class="card-label">{{card.value.cardNumber | cardFormat}}</label>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field class="w-100" *ngIf="card.value.cardBrand != 'PAYE'">
                      <mat-label>{{this.textService.keyValueMapping('cardValidDateLabel', 'Kart üzerindeki son kullanma tarihini girin', sdkInitTexts)}}</mat-label>
                      <input class="input-style" type="tel" formControlName="expirationDate" autocomplete="off"
                             maxlength="7" ccExp
                             matInput>
                      <mat-error
                        *ngIf="cardFormGroup.controls.expirationDate.errors && cardFormGroup.controls.expirationDate.errors.required">
                        {{this.textService.keyValueMapping('msgCardValidationSktRule', 'Kart son kullanma tarihi boş geçilemez.', sdkInitTexts)}}
                      </mat-error>
                      <mat-error
                        *ngIf="cardFormGroup.controls.expirationDate.errors && cardFormGroup.controls.expirationDate.errors.expDate">
                        {{this.textService.keyValueMapping('msgCardValidationSKtError', 'Son Kullanma Tarihi Hatalı veya Yanlış.', sdkInitTexts)}}
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100" *ngIf="card.value.cardBrand === 'PAYE'">
                      <mat-label>{{this.textService.keyValueMapping('payeCardLabel', 'Paye kart son 5 hane girin', sdkInitTexts)}}</mat-label>
                      <input class="input-style" type="text" autocomplete="off"
                             maxlength="5" matInput appInputRestriction="integer" formControlName="cardBrand">
                      <mat-error
                        *ngIf="cardFormGroup.controls.cardBrand.errors && cardFormGroup.controls.cardBrand.errors.required">
                        {{this.textService.keyValueMapping('msgPayeCardValidationError', 'Eksik ya da hatalı giriş yaptınız.', sdkInitTexts)}}
                      </mat-error>
                      <mat-error
                        *ngIf="cardFormGroup.controls.cardBrand.errors && cardFormGroup.controls.cardBrand.errors.minlength">
                        {{this.textService.keyValueMapping('msgPayeCardValidationError', 'Eksik ya da hatalı giriş yaptınız.', sdkInitTexts)}}
                      </mat-error>
                    </mat-form-field>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </ng-container>
          </form>
        </div>
        <div class="col-12 d-flex justify-content-center bar">
        </div>
        <div class="col-12 d-flex button-div">
          <button (click)="checkSkt()" [disabled]="isBtnDisabled()"
                  [ngClass]="(isBtnDisabled()) ? 'button-style-passive' : 'button-style'"><span
            class="text-style">{{this.textService.keyValueMapping('cardValidateButton', 'Seçilen Kartı Doğrula', sdkInitTexts)}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
